import googlePlayIcon from "../../../assets/content/teenyicons_google-play-store-outline.svg";
import appleIcon from "../../../assets/content/la_apple.svg";

export function Footer() {
  return (
    <div className="container-multicol footer-container">
      <div className="footer-mobile-icons">
        <a
          href="http://play.google.com/store/apps/details?id=com.app360plus.mobile"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="footer-mobile-icon" src={googlePlayIcon} alt="Google Play" />
        </a>
        <a
          href="https://apps.apple.com/us/app/360plus/id1571217336"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="footer-mobile-icon" src={appleIcon} alt="App Store" />
        </a>
      </div>
    </div>
  );
}
